<template>
  <section class="section has-background-grey-lighter">
    <h1
      class="
        has-text-centered has-text-weight-bold
        subtitle
        is-size-4-mobile is-size-3-desktop
        pdx-small-desktop pdx-small-touch
        has-text-left-touch
      "
    >
      Which TV Dramas are the Most Stressful to Watch?
    </h1>
    <h2
      class="
        has-text-centered
        subtitle
        is-size-6-mobile is-size-4-desktop
        pdx-large-desktop pdx-small-touch
        has-text-left-touch
      "
    >
      Among some of the most popular television dramas to have aired in recent
      years, <strong>The Walking Dead</strong> is the most stressful to watch,
      with <strong>46,088 tweets</strong> about the show classifying as
      stressed. <br /><br />The new Disney IP of <strong>Loki</strong> and
      <strong>Stranger Things</strong> also cause stress to a considerable share
      of their audiences on Twitter, with a recorded <strong>34,678</strong> and
      <strong>33,456 stressed tweets </strong> respectively.
    </h2>

    <chart-tab showType="TV Drama"></chart-tab>
  </section>
</template>

<script>
  import ChartTab from "@/components/ChartTab";
  export default {
    components: { ChartTab },
  };
</script>

<style lang="scss" scoped>
  .section {
    background: linear-gradient(#d9edf6, #ffffff);
  }
</style>
